<template>
    <b-container class="packs">
        <b-row align-h="between">
            <b-col lg="4" md="12" class="mb-4 " v-for="pack in packs" :key="pack.id">
                <list-card 
                    :title="$t('packageName', { name: pack.title })"
                    :subtitle="$t('packageTarget')"
                >
                    <div class="list-item mb-3">
                        <i class="icon-bed"></i>
                        <div>
                            <div>
                                <b v-t="'packageBenefits.accommodation.title'"></b>
                                &nbsp;
                                <span v-t="'packageBenefits.accommodation.description'"></span>
                            </div>
                        </div>
                    </div>

                    <div class="list-item mb-3">
                        <i class="icon-photos"></i>
                        <div>
                            <div>
                                <b v-t="'packageBenefits.experiences.title'"></b>
                                &nbsp;
                                <span v-t="'packageBenefits.experiences.description'"></span>
                            </div>
                        </div>
                    </div>

                    <div class="list-item mb-3">
                        <i class="icon-cards"></i>
                        <div>
                            <div>
                                <b v-t="'packageBenefits.cards.title'"></b>
                                &nbsp;
                                <span v-t="'packageBenefits.cards.description'"></span>
                            </div>
                        </div>
                    </div>

                     <div>
                         <div class="list-item__price mb-3"> {{ pack.price | currency }} </div>
    
                         <router-link :to="{ path: `/pacotes/${pack.type}` }" class="mb-3 btn btn-primary">{{ $t('knowMore') }}</router-link>

                         <div>
                             <i class="list-item__disclaimer" v-t="'disclaimer'"></i>
                         </div>
                     </div>
                    
                </list-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import { BContainer, BRow, BCol } from 'bootstrap-vue'
    import ListCard from '@/components/cards/ListCard.vue'
    import packsJson from '@/data/packs.json'

    export default {
        components: {
            ListCard,
            BContainer,
            BRow,
            BCol
        },

        data() {
            return {
                packs: packsJson
            }
        }
    }
</script>

<style lang="scss" scoped>
@import '@/assets/variables';

.packs {
    margin: 6.25rem auto;
}

.list-item {
    display: flex;
    font-weight: 400;
    text-align: left;
    font-size: 0.875rem;

    b {
        text-transform: uppercase;
        font-weight: 700;
    }

    i {
        margin: 0.3125rem 0.625rem;
    }

    &__price {
        font-size: 38px;
        font-weight: 700;
        letter-spacing: 0.95px;

        color: $primary-color;
    }

    &__disclaimer {
        font-family: "Open Sans";
        font-size: 12px;
        color: $subtitle-color;
    }
}

</style>